
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { createTheme, styled } from '@material-ui/core/styles';
import React, { useState } from 'react';
import { Box, Typography, Table as TableUi, ThemeProvider } from '@material-ui/core';
import DateToString from '../../helpers/Strings/DateToString'
import ConfirmModal, { ConfirmModalHandle } from './ConfirmModal';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
}));

const theme = createTheme({
    overrides: {
        MuiTableCell: {
            root: {
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: '3px 12px 3px 8px',
            },
        }
    }
});

interface ITableProps {
    headers: ITableHeaderProps[];
    title?: string;
    rows: any[];
    actionColumn: boolean;
    onEditClick: (e: any) => void;
    onDeleteClick: (e: any) => void;
}

export interface ITableHeaderProps {
    title: string;
    property: string;
    align?: 'inherit' | 'left' | 'center' | 'right' | 'justify';
    type: 'text' | 'date';
}

export default function Table(props: ITableProps) {

    const { headers, rows, actionColumn, title = null, onEditClick, onDeleteClick } = props;

    const modalRef = React.createRef<ConfirmModalHandle>();

    const [deleteValue, setDeleteValue] = useState();

    const handleOpenModalChild = (e: any) => {
        modalRef.current?.handleOpen(e);
        setDeleteValue(e);
    };

    const onConfirmClick = () => {
        onDeleteClick(deleteValue);
    }
    return (
        <React.Fragment>
            <Paper elevation={2} style={{ width: '100%' }} >
                <Box sx={{ width: '100%' }}>
                    {(title != null ?
                        <Box p={1}>
                            <Typography variant="overline" gutterBottom component="div">
                                {title}
                            </Typography>
                        </Box>
                        : null
                    )}
                    <ThemeProvider theme={theme}>
                        <TableContainer component={Paper}>
                            <TableUi aria-labelledby="tableTitle">
                                <TableHead>
                                    <TableRow>
                                        {headers.map((header, index) => (
                                            <TableCell key={index} align={header.align} >{header.title}</TableCell>
                                        ))}

                                        {(actionColumn ?
                                            <TableCell align="center">Ações</TableCell>
                                            : null
                                        )}

                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row, index) => (
                                        <StyledTableRow  key={index}>
                                            {headers.map((header, intexH) => (

                                                (header.type === "text" ?
                                                    <TableCell key={intexH} align={header.align}>{row[header.property]}</TableCell>
                                                    : header.type === "date" ?
                                                        <TableCell key={intexH} align={header.align}>{DateToString(row[header.property])}</TableCell>
                                                        : null
                                                )

                                            ))}

                                            {(actionColumn ?
                                                <TableCell align="center">
                                                    <IconButton aria-label="edit" color="primary" onClick={() => onEditClick(row)} >
                                                        <EditIcon />
                                                    </IconButton>
                                                    <IconButton aria-label="delete" style={{ color: "red" }} onClick={() => handleOpenModalChild(row)}  >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                                : null
                                            )}

                                        </StyledTableRow>

                                    ))}

                                    {rows.length === 0 && (
                                        <StyledTableRow>
                                            {(actionColumn ?
                                                <TableCell align="center" colSpan={headers.length + 2} >Não existem dados para serem apresentados.</TableCell>
                                                :
                                                <TableCell align="center" colSpan={headers.length + 1} >Não existem dados para serem apresentados.</TableCell>
                                            )}
                                        </StyledTableRow>
                                    )}
                                </TableBody>
                            </TableUi>
                        </TableContainer>
                    </ThemeProvider>
                </Box>
            </Paper >
            <ConfirmModal ref={modalRef} onConfirmClick={onConfirmClick} title="Confirmar a exclusão" message="Você confirma a exclusão do item selecionado ?" />
        </React.Fragment>
    )
}